import React, { useEffect,useState } from "react";
import JDsConsolidated from "../../JdsConsolidated";

export default function NuJobsAssignments(props) {
  return (
    <div className="nujobspostedjds-wrapper">
       <JDsConsolidated product = {"nujobs"}/>
    </div>  
  );
}
